import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { getCurrentUser } from '@/api/auth'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register.vue')
  },
  {
    path: '/student',
    component: () => import('@/views/student/StudentLayout.vue'),
    meta: { requiresAuth: true, role: 'STUDENT' },
    children: [
      {
        path: '',
        name: 'StudentHome',
        component: () => import('@/views/student/StudentHome.vue')
      },
      {
        path: 'papers',
        name: 'StudentPaperList',
        component: () => import('@/views/student/PaperList.vue')
      },
      {
        path: 'exam/:paperId/:recordId',
        name: 'ExamTaking',
        component: () => import('@/views/student/ExamTaking.vue')
      },
      {
        path: 'practice/:paperId',
        name: 'PracticeTaking',
        component: () => import('@/views/student/PracticeTaking.vue')
      },
      {
        path: 'result/:recordId',
        name: 'ExamResult',
        component: () => import('@/views/student/ExamResult.vue')
      },
      {
        path: 'records',
        name: 'ExamRecords',
        component: () => import('@/views/student/ExamRecords.vue')
      },
      {
        path: 'wrong-answers',
        name: 'WrongAnswers',
        component: () => import('@/views/student/WrongAnswers.vue')
      },
      {
        path: 'leaderboard',
        name: 'Leaderboard',
        component: () => import('@/views/student/Leaderboard.vue')
      },
      {
        path: 'change-password',
        name: 'ChangePassword',
        component: () => import('@/views/student/ChangePassword.vue')
      },
      {
        path: 'messages',
        name: 'MessageList',
        component: () => import('@/views/student/MessageList.vue')
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/student/Profile.vue')
      }
    ]
  },
  {
    path: '/admin',
    component: () => import('@/views/admin/AdminLayout.vue'),
    meta: { requiresAuth: true, role: 'ADMIN' },
    children: [
      {
        path: '',
        name: 'AdminHome',
        component: () => import('@/views/admin/AdminHome.vue')
      },
      {
        path: 'users',
        name: 'AdminUserList',
        component: () => import('@/views/admin/UserList.vue')
      },
      {
        path: 'papers',
        name: 'AdminPaperList',
        component: () => import('@/views/admin/PaperList.vue')
      },
      {
        path: 'papers/:paperId',
        name: 'AdminPaperDetail',
        component: () => import('@/views/admin/PaperDetail.vue')
      },
      {
        path: 'exam-records',
        name: 'AdminExamRecordList',
        component: () => import('@/views/admin/ExamRecordList.vue')
      },
      {
        path: 'grading',
        name: 'ManualGrading',
        component: () => import('@/views/admin/ManualGrading.vue')
      },
      {
        path: 'leaderboard',
        name: 'AdminLeaderboard',
        component: () => import('@/views/admin/AdminLeaderboard.vue')
      },
      {
        path: 'import-logs',
        name: 'AdminImportLogList',
        component: () => import('@/views/admin/ImportLogList.vue')
      },
      {
        path: 'messages',
        name: 'AdminMessageList',
        component: () => import('@/views/admin/AdminMessageList.vue')
      },
      {
        path: 'change-password',
        name: 'AdminChangePassword',
        component: () => import('@/views/student/ChangePassword.vue')
      },
      {
        path: 'profile',
        name: 'AdminProfile',
        component: () => import('@/views/student/Profile.vue')
      }
    ]
  },
  {
    path: '/',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

function isAdminRole(roleCode) {
  return roleCode === 'ADMIN' || roleCode === 'SUPER_ADMIN'
}

function isRoleAllowed(userRoleCode, requiredRole) {
  if (requiredRole === 'ADMIN') {
    return isAdminRole(userRoleCode)
  }
  return userRoleCode === requiredRole
}

router.beforeEach(async (to, from, next) => {
  if (to.path === '/login') {
    next()
    return
  }
  if (to.meta.requiresAuth) {
    const token = store.getters.token
    if (!token) {
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
    if (!store.getters.user) {
      try {
        const res = await getCurrentUser()
        store.dispatch('saveUser', res.data)
        if (to.meta.role && !isRoleAllowed(res.data.roleCode, to.meta.role)) {
          const target = isAdminRole(res.data.roleCode) ? '/admin' : '/student'
          next(target)
          return
        }
        next()
      } catch (e) {
        store.dispatch('logout')
        next({ path: '/login', query: { redirect: to.fullPath } })
      }
    } else {
      if (to.meta.role && !isRoleAllowed(store.getters.roleCode, to.meta.role)) {
        const target = isAdminRole(store.getters.roleCode) ? '/admin' : '/student'
        next(target)
        return
      }
      next()
    }
  } else {
    next()
  }
})

export default router
